var fn = function( obj ){
var __t,__p='';
__p+='#if __VERSION__ == 300\nIN mediump vec3 localPosition;\n#else\nvarying vec3 localPosition;\n#endif\n\n';
return __p;
};
fn.toString=fn;
module.exports = fn;